export default __webpack_public_path__ + "static/media/hayat1.202ce883.mp4";